module.exports = __webpack_public_path__ + "static/media/ss-2@2x.5e34143c.jpg";